import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import requireAuth from "../context/requireAuth";
import axios from "../context/axiosConfig";

function NewRoom() {
  const [formData, setFormData] = useState({
    room_name: "",
    roomlocation: "",
    designation: "",
    projectcode: "",
    cycleperiod: "",
    description: "",
    size_x: "",
    size_y: "",
    size_z: "",
  });

  const navigate = useNavigate();
  const org_id = localStorage.getItem("organization");

  const handleChange = ({ target: { name, value } }) =>
    setFormData((prev) => ({ ...prev, [name]: value }));

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Grab the *current* values from the form controls
    const payload = Object.fromEntries(new FormData(e.target).entries());

    try {
      payload.size_x = parseInt(payload.size_x);
      payload.size_y = parseInt(payload.size_y);
      payload.size_z = parseInt(payload.size_z);
      await axios.post(`orgs/${org_id}/rooms/`, payload, {
        withCredentials: true,
      });
      navigate("/roomselect");
    } catch (err) {
      console.error(err);
      alert("Something went wrong. Please try again.");
    }
  };

  return (
    <div className="bodyContent">
      <h1 className="title">New Room</h1>

      <div className="editFormDiv">
        <form className="editForm" onSubmit={handleSubmit}>
          <label htmlFor="room_name">Room Name</label>
          <input
            id="room_name"
            name="room_name"
            type="text"
            className="editInput newMaintenanceInput"
            placeholder="Room Name"
            value={formData.room_name}
            onChange={handleChange}
            required
          />
          <br />

          <label htmlFor="roomlocation">Room Location</label>
          <input
            id="roomlocation"
            name="roomlocation"
            type="text"
            className="editInput newMaintenanceInput"
            placeholder="Greenhouse"
            value={formData.roomlocation}
            onChange={handleChange}
          />
          <br />

          <label htmlFor="designation">Designation</label>
          <input
            id="designation"
            name="designation"
            type="text"
            className="editInput newMaintenanceInput"
            placeholder="Phenotyping test"
            value={formData.designation}
            onChange={handleChange}
          />
          <br />

          <label htmlFor="projectcode">Project Code</label>
          <input
            id="projectcode"
            name="projectcode"
            type="text"
            className="editInput newMaintenanceInput"
            placeholder="Pheno1"
            value={formData.projectcode}
            onChange={handleChange}
          />
          <br />

          <label htmlFor="cycleperiod">Cycle Period</label>
          <input
            id="cycleperiod"
            name="cycleperiod"
            type="text"
            className="editInput newMaintenanceInput"
            placeholder="12/12"
            value={formData.cycleperiod}
            onChange={handleChange}
          />
          <br />

          <label htmlFor="description">Description</label>
          <input
            id="description"
            name="description"
            type="text"
            className="editInput newMaintenanceInput"
            value={formData.description}
            onChange={handleChange}
          />
          <br />

          <label htmlFor="size_x">Columns</label>
          <input
            id="size_x"
            name="size_x"
            type="text"
            className="editInput newMaintenanceInput"
            value={formData.size_x}
            onChange={handleChange}
          />
          <br />

          {/* size_x / size_y / size_z remain text inputs as requested */}
          <label htmlFor="size_y">Rows</label>
          <input
            id="size_y"
            name="size_y"
            type="text"
            className="editInput newMaintenanceInput"
            value={formData.size_y}
            onChange={handleChange}
          />
          <br />

          <label htmlFor="size_z">Floors</label>
          <input
            id="size_z"
            name="size_z"
            type="text"
            className="editInput newMaintenanceInput"
            value={formData.size_z}
            onChange={handleChange}
          />
          <br />

          <input
            type="submit"
            value="Create Room"
            className="maintenanceFormSubmit"
          />
        </form>
      </div>
    </div>
  );
}

export default requireAuth(NewRoom);
